// @flow

import React from 'react';
import Gallery from './gallery';
import type { Image } from './types';
import type { ACFThemingOption } from '../../types/acf/themingOption';
import { joinArrayOrGetValue } from '../../helpers';

type Props = {
  variant: 'default' | 'boxed',
  has_disclaimer: boolean,
  // has_theather: boolean,
  images: false | Image[],
  video_src?: ?string,
  video_position?: ?ACFThemingOption,
  video_title?: ?string,
};

const ACFGallery = ({
  variant,
  has_disclaimer,
  images,
  video_src,
  video_position,
  video_title,
}: Props) => images && images.length > 0 && (
  <Gallery
    boxed={variant === 'boxed'}
    showDisclaimer={has_disclaimer}
    images={images}
    videoSrc={video_src}
    videoPosition={video_position && joinArrayOrGetValue(video_position)}
    videoTitle={video_title}
  />
);

ACFGallery.defaultProps = {
  video_src: null,
  video_position: 'second',
  video_title: '',
};

export default ACFGallery;
